import React from "react";
import "./Header.css";

function Header({ userInitials, onAvatarClick }) {
  return (
    <div className="hdr" data-cy="exec-header">
      <div className="logo">
        <svg height="22" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M43.8726 3.76385L9.36523 23.7634L9.40004 46.8372L23.7949 55.122L23.7639 67.6812L42.227 56.9803L42.2319 51.5751C42.2347 48.442 41.8087 45.1937 39.8621 42.7447C36.8065 38.9006 32.0736 36.6044 25.8855 35.5514C25.7869 35.5434 25.6945 35.5056 25.6243 35.4445C25.5541 35.3835 25.5105 35.303 25.501 35.2169V35.2138C25.5007 35.2066 25.5007 35.1987 25.501 35.1916L25.5009 35.1845L25.501 35.1738V35.166C25.5047 35.0765 25.5452 34.9912 25.6152 34.9257C25.6852 34.8603 25.7799 34.819 25.8818 34.8096C35.5845 33.1563 41.7104 28.4551 43.4048 19.5206C43.4124 19.4418 43.4486 19.3671 43.5082 19.3075C43.5677 19.2479 43.6475 19.2063 43.736 19.189L43.7402 19.1883C43.746 19.1872 43.7519 19.1862 43.7577 19.1853C43.7641 19.1844 43.7705 19.1835 43.7769 19.1828L43.7867 19.182L43.7925 19.1815C43.8004 19.1809 43.8082 19.1804 43.8161 19.1801C43.8226 19.18 43.8292 19.18 43.8357 19.1801C43.8426 19.1801 43.8496 19.1803 43.8565 19.1806L43.8675 19.1814C43.8692 19.1815 43.8709 19.1817 43.8726 19.1818V3.76385Z" fill="#4169E1"/>
          <path d="M43.8726 19.1818C43.877 19.1823 43.8815 19.1827 43.886 19.1833L43.8958 19.1844C43.909 19.1862 43.922 19.1885 43.935 19.1914C44.0212 19.2104 44.0985 19.2525 44.1559 19.3118C44.2134 19.371 44.2481 19.4445 44.2554 19.5219C45.9499 28.4539 52.0736 33.1546 61.7727 34.8086C61.8713 34.8167 61.9636 34.8545 62.0338 34.9156C62.104 34.9766 62.1476 35.0571 62.1571 35.1432L62.1575 35.1464V35.1473L62.1581 35.1576L62.1584 35.1686L62.1589 35.1764L62.1593 35.1837L62.1579 35.1836L62.1578 35.1863L62.157 35.1963C62.1565 35.2059 62.1557 35.2154 62.1544 35.2249C62.1429 35.3086 62.0992 35.3863 62.0305 35.4455C61.9618 35.5046 61.8721 35.5417 61.7761 35.5505C55.5875 36.6027 50.854 38.8978 47.7974 42.7407C45.8519 45.1867 45.4239 48.4313 45.4239 51.5614L45.4239 76.2362L63.5988 65.7024L63.6411 55.1219L78.2954 46.6285L78.2611 23.5546L43.8734 3.76337L43.8726 3.76386V19.1818Z" fill="#4169E1"/>
        </svg>
        <span className="logo-name">InfraNex</span>
        <span className="logo-module">Vantage</span>
      </div>
      <div className="hdr-right">
        <div className="icon-btn" data-cy="exec-notifications">
          <svg viewBox="0 0 24 24">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
        </div>
        <div
          className="icon-btn avatar"
          data-cy="exec-avatar"
          onClick={onAvatarClick}
        >
          {userInitials || "—"}
        </div>
      </div>
    </div>
  );
}

export default Header;
